unit View.Sincronizacao_Service.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UWeb.Enum, WEBLib.Grids, Grid.Plugins, System.StrUtils;

type
  TFViewSincronizacao_ServiceEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbtabela: TLabel;
    edtabela: TDBEdit;
    lbcampos_consulta: TLabel;
    edcampos_consulta: TDBEdit;
    lbrota: TLabel;
    edrota: TDBEdit;
    lbprioridade_sincronizacao: TLabel;
    edprioridade_sincronizacao: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientSincronizacao_ServiceGet: TXDataWebClient;
    Sincronizacao_ServiceDataset: TXDataWebDataSet;
    Sincronizacao_ServiceDatasetid: TIntegerField;
    Sincronizacao_ServiceDatasettabela: TStringField;
    Sincronizacao_ServiceDatasetcampos_consulta: TStringField;
    Sincronizacao_ServiceDatasetrota: TStringField;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao: TIntegerField;
    Sincronizacao_ServiceDatasetexcluido: TBooleanField;
    Sincronizacao_ServiceDatasetinclusao: TDateTimeField;
    Sincronizacao_ServiceDatasetalteracao: TDateTimeField;
    Sincronizacao_ServiceDatasetexclusao: TDateTimeField;
    Sincronizacao_ServiceDatasetconsulta_firebird: TStringField;
    lbconsulta_firebird: TLabel;
    edconsulta_firebird: TDBEdit;
    WebPanel1: TPanel;
    cbexcluido: TDBCheckBox;
    btnAliados: TButton;
    WebPanel2: TPanel;
    tblAliados: TDBTableControl;
    cdsAliados: TXDataWebDataSet;
    dtsAliados: TDataSource;
    cdsAliadosid: TIntegerField;
    cdsAliadossincronizar_dados: TBooleanField;
    cdsAliadosultima_reinicializacao: TDateTimeField;
    cdsAliadosinclusao: TDateTimeField;
    cdsAliadosalteracao: TDateTimeField;
    cdsAliadosaliadoNome_Fantasia: TXDataWebDatasetField;
    cdsAliadosselecionado: TBooleanField;
    btnMarcarDesmarcarTodos: TButton;
    btnReiniciarSincronizacao: TButton;
    cdsAliadosaliado_id: TIntegerField;
    btnDesativarSincronizacao: TButton;
    btnAtivarSincronizacao: TButton;
    XDataWebGerenciarSincronizacao: TXDataWebClient;
    cbbAliadosSize: TComboBox;
    edtAliadosSearch: TEdit;
    cdsAliadosaliadoCNPJ: TXDataWebDatasetField;
    cdsAliadosaliadosincronizar_dados: TBooleanField;
    cdsAliadosaliadoparceironome: TStringField;
    cdsAliadosaliadosegmentoNome: TStringField;
    cdsAliadosaliadocidadeufSigla: TStringField;
    cdsAliadosaliadocidadeNome: TStringField;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientSincronizacao_ServiceGetLoad(Response: TXDataClientResponse);
    procedure Sincronizacao_ServiceDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure Sincronizacao_ServiceDatasetcampos_consultaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebFormShow(Sender: TObject);
    procedure edprioridade_sincronizacaoKeyPress(Sender: TObject;
      var Key: Char);
    procedure edtabelaClick(Sender: TObject);
    procedure edcampos_consultaClick(Sender: TObject);
    procedure edrotaClick(Sender: TObject);
    procedure edprioridade_sincronizacaoClick(Sender: TObject);
    procedure edconsulta_firebirdClick(Sender: TObject);
    procedure btnAliadosClick(Sender: TObject);
    procedure cdsAliadosAfterOpen(DataSet: TDataSet);
    procedure tblAliadosGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblAliadosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblAliadosGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure btnMarcarDesmarcarTodosClick(Sender: TObject);
    procedure btnReiniciarSincronizacaoClick(Sender: TObject);
    procedure btnDesativarSincronizacaoClick(Sender: TObject);
    procedure btnAtivarSincronizacaoClick(Sender: TObject);
    procedure XDataWebGerenciarSincronizacaoError(Error: TXDataClientError);
    procedure XDataWebGerenciarSincronizacaoLoad(
      Response: TXDataClientResponse);
    procedure cdsAliadosaliadoparceironomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure cdsAliadosaliadosegmentoNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure cdsAliadosaliadoNome_FantasiaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure cdsAliadosaliadoCNPJGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsAliadosaliadocidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FPaginacaoAliadosConfigurada: Boolean;
    FQuantidadeSelecionada : Integer;
    FSelecionados : TStringList;
    FTodosAliados : TStringList;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ConfigurarPaginacaoAliados;
    procedure AtualizarTabelaAliados(const pPage: Integer = 1);
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    function ValidarDados : TArray<string>;
    procedure ConfigurarBotaoMarcarDesmarcarTodos(pMarcar : Boolean);
    function GetListaSelecionados : string;
    [async]
    procedure RealizarOperacao(pTipoOperacao : string); async;
    procedure IniciarDataSetAliados;
    procedure DesabilitarComponentes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_ServiceEdit: TFViewSincronizacao_ServiceEdit;

implementation

uses
  ConnectionModule, UClientTablePagination;

{$R *.dfm}

{ TFViewSincronizacao_ServiceEdit }

procedure TFViewSincronizacao_ServiceEdit.btnAliadosClick(Sender: TObject);
begin
  IniciarDataSetAliados;
end;

procedure TFViewSincronizacao_ServiceEdit.btnAtivarSincronizacaoClick(
  Sender: TObject);
begin
  RealizarOperacao('ATIVAR SINCRONIZAÇÃO');
end;

procedure TFViewSincronizacao_ServiceEdit.btnDesativarSincronizacaoClick(
  Sender: TObject);
begin
  RealizarOperacao('DESATIVAR SINCRONIZAÇÃO');
end;

procedure TFViewSincronizacao_ServiceEdit.btnMarcarDesmarcarTodosClick(
  Sender: TObject);
var
  lMarcar : Boolean;
begin
  lMarcar := btnMarcarDesmarcarTodos.Tag = 0;

  FSelecionados.Clear;

  if lMarcar then
    FSelecionados.Assign(FTodosAliados);

  FQuantidadeSelecionada := FSelecionados.Count;

  asm
    var lBoxes = document.querySelectorAll('#tblAliados input[type="checkbox"]');
    for (var i = 0; i < lBoxes.length; i++) {
      lBoxes[i].checked = lMarcar;
    }
  end;

  ConfigurarBotaoMarcarDesmarcarTodos(not lMarcar);
end;

procedure TFViewSincronizacao_ServiceEdit.btnReiniciarSincronizacaoClick(
  Sender: TObject);
begin
  RealizarOperacao('REINICIAR SINCRONIZAÇÃO');
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosAfterOpen(DataSet: TDataSet);
begin
  ConfigurarPaginacaoAliados;
  AtualizarTabelaAliados(1);

  TUtils.OcultarDivLoading;
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosaliadocidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, cdsAliados.FieldByName('aliado.cidade.uf.Sigla').AsString);
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosaliadoCNPJGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosaliadoNome_FantasiaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosaliadoparceironomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewSincronizacao_ServiceEdit.cdsAliadosaliadosegmentoNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewSincronizacao_ServiceEdit.ConfigurarBotaoMarcarDesmarcarTodos(
  pMarcar: Boolean);
begin
  if pMarcar then
  begin
    asm
      document.getElementById('btnMarcarDesmarcarTodos').innerHTML = '<span class="btn-label"><i class="fas fa-check-square"></i></span> Marcar Todos';
    end;

    btnMarcarDesmarcarTodos.Tag := 0;
  end
  else
  begin
    asm
      document.getElementById('btnMarcarDesmarcarTodos').innerHTML = '<span class="btn-label"><i class="far fa-square"></i></span> Desmarcar Todos';
    end;

    btnMarcarDesmarcarTodos.Tag := 1;
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.ConfigurarPaginacaoAliados;
begin
  if FPaginacaoAliadosConfigurada then
    Exit;

  FPaginacaoAliadosConfigurada := True;

  asm
    var lSelect = document.getElementById('aliados_page_size');
    if (lSelect && lSelect.options.length === 0) {
      var lSizes = [10, 25, 50, 100];
      lSizes.forEach(function(lSize) {
        var lOption = document.createElement('option');
        lOption.value = String(lSize);
        lOption.textContent = String(lSize);
        lSelect.appendChild(lOption);
      });
      lSelect.value = '10';
    }

    var lApply = function() {
      pas.UClientTablePagination.TClientTablePagination.ApplyFromControls(
        'tblAliados', 'aliados_paginacao_info', 'aliados_list_paginacao',
        'aliados_page_size', 'aliados_search', 10, 1, false);
    };

    if (lSelect && !lSelect.getAttribute('data-paginacao-bound')) {
      lSelect.setAttribute('data-paginacao-bound', '1');
      lSelect.addEventListener('change', lApply);
    }

    var lSearch = document.getElementById('aliados_search');
    if (lSearch && !lSearch.getAttribute('data-paginacao-bound')) {
      lSearch.setAttribute('data-paginacao-bound', '1');
      lSearch.addEventListener('input', lApply);
    }
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.AtualizarTabelaAliados(const pPage: Integer);
begin
  TClientTablePagination.ApplyFromControlsAsync('tblAliados',
    'aliados_paginacao_info', 'aliados_list_paginacao', 'aliados_page_size',
    'aliados_search', 10, pPage, True);
end;

procedure TFViewSincronizacao_ServiceEdit.btSaveClick(Sender: TObject);
var
  lMensagem : string;
  lErro : TArray<string>;
begin
  lErro := ValidarDados;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  lMensagem := 'Tem certeza que deseja cadastrar essa sincronização?';

  if not FInserting then
    lMensagem := 'Tem certeza que deseja alterar essa sincronização?';

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
  begin
    TUtils.ChamarDivLoading;

    if Sincronizacao_ServiceDataset.State in dsEditModes then
    begin
      Sincronizacao_ServiceDataset.FieldByName('campos_consulta').AsString := THelperServer.FormatarJSON(edcampos_consulta.Text, False);
      Sincronizacao_ServiceDataset.Post;
      Sincronizacao_ServiceDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewSincronizacao_ServiceEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSincronizacao_ServiceEdit.DesabilitarComponentes;
begin
  btSave.Enabled := False;
  edtabela.Enabled := False;
  edrota.Enabled := False;
  edconsulta_firebird.Enabled := False;
  edcampos_consulta.Enabled := False;
  edprioridade_sincronizacao.Enabled := False;
  cbexcluido.Enabled := False;
end;

procedure TFViewSincronizacao_ServiceEdit.edcampos_consultaClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_service_form_lbcampos_consulta');
end;

procedure TFViewSincronizacao_ServiceEdit.edconsulta_firebirdClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_service_form_lbconsulta_firebird');
end;

procedure TFViewSincronizacao_ServiceEdit.edprioridade_sincronizacaoClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_service_form_lbprioridade_sincronizacao');
end;

procedure TFViewSincronizacao_ServiceEdit.edprioridade_sincronizacaoKeyPress(
  Sender: TObject; var Key: Char);
begin
  if not(key in ['0'..'9', '.']) Then
    key := #0;
end;

procedure TFViewSincronizacao_ServiceEdit.edrotaClick(Sender: TObject);
begin
    TUtils.RemoverErroClass('view_sincronizacao_service_form_lbrota');
end;

procedure TFViewSincronizacao_ServiceEdit.edtabelaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_sincronizacao_service_form_lbtabela');
end;

function TFViewSincronizacao_ServiceEdit.GetListaSelecionados: string;
begin
  Result := EmptyStr;

  if FQuantidadeSelecionada <= 0 then
    Exit;

  if FQuantidadeSelecionada = cdsAliados.RecordCount then
  begin
    Result := 'TODOS';
    Exit;
  end;

  Result := String.Join(', ', FSelecionados.ToStringArray);
end;

procedure TFViewSincronizacao_ServiceEdit.IniciarDataSetAliados;
begin
  if cdsAliados.Tag = 0 then
  begin
    TUtils.ChamarDivLoading;

    if not Assigned(FSelecionados) then
      FSelecionados := TStringList.Create;

    if not Assigned(FTodosAliados) then
      FTodosAliados := TStringList.Create;

    FSelecionados.Clear;
    FTodosAliados.Clear;
    FQuantidadeSelecionada := 0;

    cdsAliados.DisableControls;

    try
      cdsAliados.Close;
      cdsAliados.QueryString := '$filter=sincronizacao_service_id eq ' +edid.Text+
        '&$expand=aliado, aliado/segmento, aliado/cidade, aliado/cidade/uf, aliado/parceiro';
      cdsAliados.QueryTop := -1;
      cdsAliados.Load;
    finally
      cdsAliados.Tag := 1;
      cdsAliados.EnableControls;
    end;
  end;

  if not TUtils.PossuiPermissao(cdsAliados.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    btnMarcarDesmarcarTodos.Enabled := False;
    btnAtivarSincronizacao.Enabled := False;
    btnDesativarSincronizacao.Enabled := False;
    btnReiniciarSincronizacao.Enabled := False;
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.InsertEntity;
begin
  Sincronizacao_ServiceDataset.Close;
  Sincronizacao_ServiceDataset.SetJsonData('{}');
  Sincronizacao_ServiceDataset.Open;
  Sincronizacao_ServiceDataset.Insert;
end;

class function TFViewSincronizacao_ServiceEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_ServiceEdit(AForm).FInserting := AInserting;
    TFViewSincronizacao_ServiceEdit(AForm).FId := AId;
    TFViewSincronizacao_ServiceEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSincronizacao_ServiceEdit(AForm).InsertEntity
    else
      TFViewSincronizacao_ServiceEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_ServiceEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_ServiceEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Sincronizacao_ServiceDataset.Connection.Model.DefaultSchema.FindEntityType(
      Sincronizacao_ServiceDataset.EntitySetName
    )
  );
  XDataClientSincronizacao_ServiceGet.Get(Sincronizacao_ServiceDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSincronizacao_ServiceEdit.RealizarOperacao(pTipoOperacao: string);
var
  lSelecionados : string;
  lJson : TJSObject;
begin
  lSelecionados := GetListaSelecionados;

  if lSelecionados.IsEmpty then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum aliado selecionado!')
  else
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
    begin
      TUtils.ChamarDivLoading;

      lJson := TJSObject.New;

      if lSelecionados = 'TODOS' then
      begin
        lJson['sincronizacao_aliados_id'] := 'TODOS';
        lJson['sincronizacao_service_id'] := edid.Text;
      end
      else
        lJson['sincronizacao_aliados_id'] := lSelecionados;

      lJson['operacao'] := pTipoOperacao;

      XDataWebGerenciarSincronizacao.RawInvoke('IService.GerenciarSincronizacaoAliados', [lJson]);
    end;
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.XDataClientSincronizacao_ServiceGetLoad(Response: TXDataClientResponse);
begin
  Sincronizacao_ServiceDataset.Close;
  Sincronizacao_ServiceDataset.SetJsonData(Response.Result);
  Sincronizacao_ServiceDataset.Open;

  Sincronizacao_ServiceDataset.Edit;  
end;

procedure TFViewSincronizacao_ServiceEdit.XDataWebGerenciarSincronizacaoError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewSincronizacao_ServiceEdit.XDataWebGerenciarSincronizacaoLoad(
  Response: TXDataClientResponse);
begin
  cdsAliados.Tag := 0;
  cbbAliadosSize.ItemIndex := 0;
  edtAliadosSearch.Text := EmptyStr;
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  ConfigurarBotaoMarcarDesmarcarTodos(True);
  btnAliados.Click;
end;

procedure TFViewSincronizacao_ServiceEdit.Sincronizacao_ServiceDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);

      Sincronizacao_ServiceDataset.Edit;

      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewSincronizacao_ServiceEdit.Sincronizacao_ServiceDatasetcampos_consultaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not FInserting then
    Text := THelperServer.FormatarJSON(Sender.AsString, True);
end;

procedure TFViewSincronizacao_ServiceEdit.tblAliadosGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  lId : string;
procedure CheckBoxClick(Sender: TObject);
var
  lCheckBoxSelecionado: TCheckBox;
  lIndice : Integer;
begin
  lCheckBoxSelecionado := TCheckBox(Sender);

  if lCheckBoxSelecionado.Checked then
  begin
    if FSelecionados.IndexOf(lId) < 0 then
      FSelecionados.Add(lId);
  end
  else
  begin
    lIndice := FSelecionados.IndexOf(lId);
    if lIndice >= 0 then
      FSelecionados.Delete(lIndice);
  end;


  FQuantidadeSelecionada := FSelecionados.Count;

  if FQuantidadeSelecionada = cdsAliados.RecordCount then
    ConfigurarBotaoMarcarDesmarcarTodos(False)
  else if FQuantidadeSelecionada <= 0 then
    ConfigurarBotaoMarcarDesmarcarTodos(True);
end;
var
  lCheckBox : TCheckBox;
begin
  if ARow = 0 then
    Exit;

  if tblAliados.Columns[ACol].Title = 'Selecionar' then
  begin
    lId := cdsAliados.FieldByName('id').AsString;

    if FTodosAliados.IndexOf(lId) < 0 then
      FTodosAliados.Add(lId);

    lCheckBox := TCheckBox.Create(nil);

    lCheckBox.OnClick := @CheckBoxClick;
    lCheckBox.ElementClassName := 'checkbox-table';
    lCheckBox.ParentElement := AElement.element;
    lCheckBox.WidthStyle := TSizeStyle.ssAuto;
    lCheckBox.HeightStyle := TSizeStyle.ssAuto;
    lCheckBox.ElementHandle.setAttribute('data-test', 'cbx_selecionar_aliado');
    lCheckBox.Checked := FSelecionados.IndexOf(lId) >= 0;
    lCheckBox.Enabled := TUtils.PossuiPermissao(cdsAliados.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.tblAliadosGetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAliados.Columns[ACol].DataField, ['aliado.Nome_Fantasia',
      'aliado.segmento.Nome', 'aliado.cidade.Nome', 'aliado.parceiro.nome']) of
      0, 1, 2, 3: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.tblAliadosGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblAliados.Columns[ACol].DataField, ['sincronizar_dados', 'aliado.sincronizar_dados']) of
      0, 1:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success" data-sort-value="1"></i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger" data-sort-value="0"></i>'
      end;
    end;
  end;
end;

function TFViewSincronizacao_ServiceEdit.ValidarDados: TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := '';

  if THelperServer.VerificarCampoVazio(edtabela) then
  begin
    Result[0] := 'Insira o nome da tabela no retaguarda!';
    Result[1] := 'view_sincronizacao_service_form_lbtabela';
  end
  else if THelperServer.VerificarCampoVazio(edrota) then
  begin
    Result[0] := 'Insira o nome da tabela no servidor!';
    Result[1] := 'view_sincronizacao_service_form_lbrota';
  end
  else if THelperServer.VerificarCampoVazio(edprioridade_sincronizacao) then
  begin
    Result[0] := 'Insira a prioridade de sincronização!';
    Result[1] := 'view_sincronizacao_service_form_lbprioridade_sincronizacao';
  end
  else if (StrToInt(edprioridade_sincronizacao.Text) < 1) or (StrToInt(edprioridade_sincronizacao.Text) > 3) then
  begin
    Result[0] := 'Valor deve estar entre 1 e 3!';
    Result[1] := 'view_sincronizacao_service_form_lbprioridade_sincronizacao';
  end
  else if THelperServer.VerificarCampoVazio(edcampos_consulta) then
  begin
    Result[0] := 'Insira o json com os campos da consulta!';
    Result[1] := 'view_sincronizacao_service_form_lbcampos_consulta';
  end
  else if not THelperServer.VerificarJsonValido(edcampos_consulta.Text) then
  begin
    Result[0] := 'Json inserido é inválido!';
    Result[1] := 'view_sincronizacao_service_form_lbcampos_consulta';
  end
  else if not THelperServer.VerificarCampoVazio(edconsulta_firebird) and
    not THelperServer.IsSelectSomente(edconsulta_firebird.Text) then
  begin
    Result[0] := 'A consulta inserida deve ser um SELECT!';
    Result[1] := 'view_sincronizacao_service_form_lbconsulta_firebird';
  end;
end;

procedure TFViewSincronizacao_ServiceEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
  begin
    THelperServer.RemoverDiv('campos-controle');
    THelperServer.RemoverElementoPorId(btnAliados.ElementID);
    THelperServer.RemoverElementoPorId('line-aliados');

    if not TUtils.PossuiPermissao(Sincronizacao_ServiceDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
      DesabilitarComponentes;
  end
  else
  begin
    if not TUtils.PossuiPermissao(Sincronizacao_ServiceDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
      DesabilitarComponentes;

    if not TUtils.PossuiPermissao(cdsAliados.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
    begin
      THelperServer.RemoverElementoPorId(btnAliados.ElementID);
      THelperServer.RemoverElementoPorId('line-aliados');
    end;
  end;

  FQuantidadeSelecionada := 0;
end;

procedure TFViewSincronizacao_ServiceEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_ServiceEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.sincronizacao_service.form.lbid');
  lbtabela := TLabel.Create('view.sincronizacao_service.form.lbtabela');
  lbcampos_consulta := TLabel.Create('view.sincronizacao_service.form.lbcampos_consulta');
  lbrota := TLabel.Create('view.sincronizacao_service.form.lbrota');
  lbprioridade_sincronizacao := TLabel.Create('view.sincronizacao_service.form.lbprioridade_sincronizacao');
  lbexcluido := TLabel.Create('view.sincronizacao_service.form.lbexcluido');
  lbinclusao := TLabel.Create('view.sincronizacao_service.form.lbinclusao');
  lbalteracao := TLabel.Create('view.sincronizacao_service.form.lbalteracao');
  lbexclusao := TLabel.Create('view.sincronizacao_service.form.lbexclusao');
  lbconsulta_firebird := TLabel.Create('view.sincronizacao_service.form.lbconsulta_firebird');
  btCancel := TButton.Create('view.sincronizacao_service.form.btBack');
  btSave := TButton.Create('view.sincronizacao_service.form.btSave');
  edid := TDBEdit.Create('view.sincronizacao_service.form.edid');
  edtabela := TDBEdit.Create('view.sincronizacao_service.form.edtabela');
  edcampos_consulta := TDBEdit.Create('view.sincronizacao_service.form.edcampos_consulta');
  edrota := TDBEdit.Create('view.sincronizacao_service.form.edrota');
  edprioridade_sincronizacao := TDBEdit.Create('view.sincronizacao_service.form.edprioridade_sincronizacao');
  edinclusao := TDBEdit.Create('view.sincronizacao_service.form.edinclusao');
  edalteracao := TDBEdit.Create('view.sincronizacao_service.form.edalteracao');
  edexclusao := TDBEdit.Create('view.sincronizacao_service.form.edexclusao');
  edconsulta_firebird := TDBEdit.Create('view.sincronizacao_service.form.edconsulta_firebird');
  WebPanel1 := TPanel.Create(Self);
  cbexcluido := TDBCheckBox.Create('view.sincronizacao_service.form.cbexcluido');
  btnAliados := TButton.Create('line-aliados-tab');
  WebPanel2 := TPanel.Create(Self);
  tblAliados := TDBTableControl.Create('tblAliados');
  btnMarcarDesmarcarTodos := TButton.Create('btnMarcarDesmarcarTodos');
  btnReiniciarSincronizacao := TButton.Create('btnReiniciarSincronizacao');
  btnDesativarSincronizacao := TButton.Create('btnDesativarSincronizacao');
  btnAtivarSincronizacao := TButton.Create('btnAtivarSincronizacao');
  cbbAliadosSize := TComboBox.Create('aliados_page_size');
  edtAliadosSearch := TEdit.Create('aliados_search');
  DataSource := TDataSource.Create(Self);
  Sincronizacao_ServiceDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_ServiceDatasetid := TIntegerField.Create(Self);
  Sincronizacao_ServiceDatasettabela := TStringField.Create(Self);
  Sincronizacao_ServiceDatasetcampos_consulta := TStringField.Create(Self);
  Sincronizacao_ServiceDatasetrota := TStringField.Create(Self);
  Sincronizacao_ServiceDatasetprioridade_sincronizacao := TIntegerField.Create(Self);
  Sincronizacao_ServiceDatasetexcluido := TBooleanField.Create(Self);
  Sincronizacao_ServiceDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_ServiceDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_ServiceDatasetexclusao := TDateTimeField.Create(Self);
  Sincronizacao_ServiceDatasetconsulta_firebird := TStringField.Create(Self);
  XDataClientSincronizacao_ServiceGet := TXDataWebClient.Create(Self);
  cdsAliados := TXDataWebDataSet.Create(Self);
  cdsAliadosid := TIntegerField.Create(Self);
  cdsAliadossincronizar_dados := TBooleanField.Create(Self);
  cdsAliadosultima_reinicializacao := TDateTimeField.Create(Self);
  cdsAliadosinclusao := TDateTimeField.Create(Self);
  cdsAliadosalteracao := TDateTimeField.Create(Self);
  cdsAliadosaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  cdsAliadosselecionado := TBooleanField.Create(Self);
  cdsAliadosaliado_id := TIntegerField.Create(Self);
  cdsAliadosaliadoCNPJ := TXDataWebDatasetField.Create(Self);
  cdsAliadosaliadosincronizar_dados := TBooleanField.Create(Self);
  cdsAliadosaliadoparceironome := TStringField.Create(Self);
  cdsAliadosaliadosegmentoNome := TStringField.Create(Self);
  cdsAliadosaliadocidadeufSigla := TStringField.Create(Self);
  cdsAliadosaliadocidadeNome := TStringField.Create(Self);
  dtsAliados := TDataSource.Create(Self);
  XDataWebGerenciarSincronizacao := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbtabela.BeforeLoadDFMValues;
  lbcampos_consulta.BeforeLoadDFMValues;
  lbrota.BeforeLoadDFMValues;
  lbprioridade_sincronizacao.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbconsulta_firebird.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edtabela.BeforeLoadDFMValues;
  edcampos_consulta.BeforeLoadDFMValues;
  edrota.BeforeLoadDFMValues;
  edprioridade_sincronizacao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  edconsulta_firebird.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  cbexcluido.BeforeLoadDFMValues;
  btnAliados.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  tblAliados.BeforeLoadDFMValues;
  btnMarcarDesmarcarTodos.BeforeLoadDFMValues;
  btnReiniciarSincronizacao.BeforeLoadDFMValues;
  btnDesativarSincronizacao.BeforeLoadDFMValues;
  btnAtivarSincronizacao.BeforeLoadDFMValues;
  cbbAliadosSize.BeforeLoadDFMValues;
  edtAliadosSearch.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Sincronizacao_ServiceDataset.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetid.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasettabela.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetcampos_consulta.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetrota.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetprioridade_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetexcluido.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetexclusao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetconsulta_firebird.BeforeLoadDFMValues;
  XDataClientSincronizacao_ServiceGet.BeforeLoadDFMValues;
  cdsAliados.BeforeLoadDFMValues;
  cdsAliadosid.BeforeLoadDFMValues;
  cdsAliadossincronizar_dados.BeforeLoadDFMValues;
  cdsAliadosultima_reinicializacao.BeforeLoadDFMValues;
  cdsAliadosinclusao.BeforeLoadDFMValues;
  cdsAliadosalteracao.BeforeLoadDFMValues;
  cdsAliadosaliadoNome_Fantasia.BeforeLoadDFMValues;
  cdsAliadosselecionado.BeforeLoadDFMValues;
  cdsAliadosaliado_id.BeforeLoadDFMValues;
  cdsAliadosaliadoCNPJ.BeforeLoadDFMValues;
  cdsAliadosaliadosincronizar_dados.BeforeLoadDFMValues;
  cdsAliadosaliadoparceironome.BeforeLoadDFMValues;
  cdsAliadosaliadosegmentoNome.BeforeLoadDFMValues;
  cdsAliadosaliadocidadeufSigla.BeforeLoadDFMValues;
  cdsAliadosaliadocidadeNome.BeforeLoadDFMValues;
  dtsAliados.BeforeLoadDFMValues;
  XDataWebGerenciarSincronizacao.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_ServiceEdit';
    Width := 490;
    Height := 524;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 34;
    lbid.Width := 27;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd.:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbtabela.SetParentComponent(Self);
    lbtabela.Name := 'lbtabela';
    lbtabela.Left := 8;
    lbtabela.Top := 61;
    lbtabela.Width := 96;
    lbtabela.Height := 13;
    lbtabela.Caption := 'Tabela Retaguarda:';
    lbtabela.HeightPercent := 100.000000000000000000;
    lbtabela.WidthPercent := 100.000000000000000000;
    lbcampos_consulta.SetParentComponent(Self);
    lbcampos_consulta.Name := 'lbcampos_consulta';
    lbcampos_consulta.Left := 8;
    lbcampos_consulta.Top := 88;
    lbcampos_consulta.Width := 87;
    lbcampos_consulta.Height := 13;
    lbcampos_consulta.Caption := 'Campos Consulta:';
    lbcampos_consulta.HeightPercent := 100.000000000000000000;
    lbcampos_consulta.WidthPercent := 100.000000000000000000;
    lbrota.SetParentComponent(Self);
    lbrota.Name := 'lbrota';
    lbrota.Left := 8;
    lbrota.Top := 115;
    lbrota.Width := 79;
    lbrota.Height := 13;
    lbrota.Caption := 'Tabela Servidor:';
    lbrota.HeightPercent := 100.000000000000000000;
    lbrota.WidthPercent := 100.000000000000000000;
    lbprioridade_sincronizacao.SetParentComponent(Self);
    lbprioridade_sincronizacao.Name := 'lbprioridade_sincronizacao';
    lbprioridade_sincronizacao.Left := 8;
    lbprioridade_sincronizacao.Top := 142;
    lbprioridade_sincronizacao.Width := 78;
    lbprioridade_sincronizacao.Height := 13;
    lbprioridade_sincronizacao.Caption := 'Prioridade Sinc.:';
    lbprioridade_sincronizacao.HeightPercent := 100.000000000000000000;
    lbprioridade_sincronizacao.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 169;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 264;
    lbinclusao.Top := 34;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 264;
    lbalteracao.Top := 61;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 264;
    lbexclusao.Top := 88;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbconsulta_firebird.SetParentComponent(Self);
    lbconsulta_firebird.Name := 'lbconsulta_firebird';
    lbconsulta_firebird.Left := 264;
    lbconsulta_firebird.Top := 117;
    lbconsulta_firebird.Width := 85;
    lbconsulta_firebird.Height := 13;
    lbconsulta_firebird.Caption := 'Consulta Firebird:';
    lbconsulta_firebird.HeightPercent := 100.000000000000000000;
    lbconsulta_firebird.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 366;
    btCancel.Top := 164;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 264;
    btSave.Top := 164;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 149;
    edid.Top := 31;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edtabela.SetParentComponent(Self);
    edtabela.Name := 'edtabela';
    edtabela.Left := 149;
    edtabela.Top := 58;
    edtabela.Width := 100;
    edtabela.Height := 21;
    edtabela.CharCase := wecUpperCase;
    edtabela.HeightPercent := 100.000000000000000000;
    edtabela.TabOrder := 7;
    edtabela.Text := 'edtabela';
    edtabela.WidthPercent := 100.000000000000000000;
    SetEvent(edtabela, Self, 'OnClick', 'edtabelaClick');
    edtabela.DataField := 'tabela';
    edtabela.DataSource := DataSource;
    edcampos_consulta.SetParentComponent(Self);
    edcampos_consulta.Name := 'edcampos_consulta';
    edcampos_consulta.Left := 149;
    edcampos_consulta.Top := 85;
    edcampos_consulta.Width := 100;
    edcampos_consulta.Height := 21;
    edcampos_consulta.HeightPercent := 100.000000000000000000;
    edcampos_consulta.TabOrder := 8;
    edcampos_consulta.Text := 'edcampos_consulta';
    edcampos_consulta.WidthPercent := 100.000000000000000000;
    SetEvent(edcampos_consulta, Self, 'OnClick', 'edcampos_consultaClick');
    edcampos_consulta.DataField := 'campos_consulta';
    edcampos_consulta.DataSource := DataSource;
    edrota.SetParentComponent(Self);
    edrota.Name := 'edrota';
    edrota.Left := 149;
    edrota.Top := 112;
    edrota.Width := 100;
    edrota.Height := 21;
    edrota.CharCase := wecLowerCase;
    edrota.HeightPercent := 100.000000000000000000;
    edrota.TabOrder := 9;
    edrota.Text := 'edrota';
    edrota.WidthPercent := 100.000000000000000000;
    SetEvent(edrota, Self, 'OnClick', 'edrotaClick');
    edrota.DataField := 'rota';
    edrota.DataSource := DataSource;
    edprioridade_sincronizacao.SetParentComponent(Self);
    edprioridade_sincronizacao.Name := 'edprioridade_sincronizacao';
    edprioridade_sincronizacao.Left := 149;
    edprioridade_sincronizacao.Top := 139;
    edprioridade_sincronizacao.Width := 100;
    edprioridade_sincronizacao.Height := 21;
    edprioridade_sincronizacao.HeightPercent := 100.000000000000000000;
    edprioridade_sincronizacao.TabOrder := 10;
    edprioridade_sincronizacao.Text := 'edprioridade_sincronizacao';
    edprioridade_sincronizacao.WidthPercent := 100.000000000000000000;
    SetEvent(edprioridade_sincronizacao, Self, 'OnClick', 'edprioridade_sincronizacaoClick');
    SetEvent(edprioridade_sincronizacao, Self, 'OnKeyPress', 'edprioridade_sincronizacaoKeyPress');
    edprioridade_sincronizacao.DataField := 'prioridade_sincronizacao';
    edprioridade_sincronizacao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 373;
    edinclusao.Top := 31;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 12;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 373;
    edalteracao.Top := 58;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 13;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 373;
    edexclusao.Top := 85;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 14;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    edconsulta_firebird.SetParentComponent(Self);
    edconsulta_firebird.Name := 'edconsulta_firebird';
    edconsulta_firebird.Left := 373;
    edconsulta_firebird.Top := 114;
    edconsulta_firebird.Width := 100;
    edconsulta_firebird.Height := 21;
    edconsulta_firebird.ChildOrder := 21;
    edconsulta_firebird.HeightPercent := 100.000000000000000000;
    edconsulta_firebird.TabOrder := 14;
    edconsulta_firebird.Text := 'edconsulta_firebird';
    edconsulta_firebird.WidthPercent := 100.000000000000000000;
    SetEvent(edconsulta_firebird, Self, 'OnClick', 'edconsulta_firebirdClick');
    edconsulta_firebird.DataField := 'consulta_firebird';
    edconsulta_firebird.DataSource := DataSource;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 8;
    WebPanel1.Width := 465;
    WebPanel1.Height := 17;
    WebPanel1.Caption := 'Espa'#231'o form';
    WebPanel1.ChildOrder := 23;
    WebPanel1.Color := clInfoText;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWhite;
    WebPanel1.Font.Height := -11;
    WebPanel1.Font.Name := 'Tahoma';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 11;
    WebPanel1.Visible := False;
    cbexcluido.SetParentComponent(Self);
    cbexcluido.Name := 'cbexcluido';
    cbexcluido.Left := 149;
    cbexcluido.Top := 166;
    cbexcluido.Width := 100;
    cbexcluido.Height := 22;
    cbexcluido.Caption := 'cbexcluido';
    cbexcluido.ChildOrder := 13;
    cbexcluido.HeightPercent := 100.000000000000000000;
    cbexcluido.WidthPercent := 100.000000000000000000;
    cbexcluido.DataField := 'excluido';
    cbexcluido.DataSource := DataSource;
    btnAliados.SetParentComponent(Self);
    btnAliados.Name := 'btnAliados';
    btnAliados.Left := 8;
    btnAliados.Top := 436;
    btnAliados.Width := 96;
    btnAliados.Height := 25;
    btnAliados.Caption := 'Aliados';
    btnAliados.ChildOrder := 23;
    btnAliados.HeightPercent := 100.000000000000000000;
    btnAliados.TabOrder := 4;
    btnAliados.WidthPercent := 100.000000000000000000;
    SetEvent(btnAliados, Self, 'OnClick', 'btnAliadosClick');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 8;
    WebPanel2.Top := 256;
    WebPanel2.Width := 465;
    WebPanel2.Height := 17;
    WebPanel2.Caption := 'Espa'#231'o tabela aliados';
    WebPanel2.ChildOrder := 23;
    WebPanel2.Color := clInfoText;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWhite;
    WebPanel2.Font.Height := -11;
    WebPanel2.Font.Name := 'Tahoma';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 14;
    WebPanel2.Visible := False;
    tblAliados.SetParentComponent(Self);
    tblAliados.Name := 'tblAliados';
    tblAliados.Left := 8;
    tblAliados.Top := 279;
    tblAliados.Width := 465;
    tblAliados.Height := 146;
    tblAliados.ElementClassName := 'table-responsive';
    tblAliados.BorderColor := clSilver;
    tblAliados.ChildOrder := 25;
    tblAliados.ColHeader := False;
    tblAliados.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAliados, Self, 'OnGetCellData', 'tblAliadosGetCellData');
    SetEvent(tblAliados, Self, 'OnGetCellChildren', 'tblAliadosGetCellChildren');
    SetEvent(tblAliados, Self, 'OnGetCellClass', 'tblAliadosGetCellClass');
    tblAliados.Columns.Clear;
    with tblAliados.Columns.Add do
    begin
      Tag := 1;
      Title := 'Selecionar';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.CNPJ';
      Title := 'CNPJ';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'sincronizar_dados';
      Title := 'Sincronizar Rota';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.sincronizar_dados';
      Title := 'Sinc. Ativa Aliado';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'ultima_reinicializacao';
      Title := #218'lt. Reinicializa'#231#227'o';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.segmento.Nome';
      Title := 'SEGMENTO';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.cidade.Nome';
      Title := 'CIDADE';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'aliado.parceiro.nome';
      Title := 'PARCEIRO';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblAliados.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    tblAliados.DataSource := dtsAliados;
    btnMarcarDesmarcarTodos.SetParentComponent(Self);
    btnMarcarDesmarcarTodos.Name := 'btnMarcarDesmarcarTodos';
    btnMarcarDesmarcarTodos.Left := 110;
    btnMarcarDesmarcarTodos.Top := 436;
    btnMarcarDesmarcarTodos.Width := 96;
    btnMarcarDesmarcarTodos.Height := 25;
    btnMarcarDesmarcarTodos.Caption := 'Marcar Todos';
    btnMarcarDesmarcarTodos.ChildOrder := 23;
    btnMarcarDesmarcarTodos.HeightPercent := 100.000000000000000000;
    btnMarcarDesmarcarTodos.TabOrder := 4;
    btnMarcarDesmarcarTodos.WidthPercent := 100.000000000000000000;
    SetEvent(btnMarcarDesmarcarTodos, Self, 'OnClick', 'btnMarcarDesmarcarTodosClick');
    btnReiniciarSincronizacao.SetParentComponent(Self);
    btnReiniciarSincronizacao.Name := 'btnReiniciarSincronizacao';
    btnReiniciarSincronizacao.Left := 218;
    btnReiniciarSincronizacao.Top := 436;
    btnReiniciarSincronizacao.Width := 96;
    btnReiniciarSincronizacao.Height := 25;
    btnReiniciarSincronizacao.Caption := 'Reiniciar Sinc. Rota';
    btnReiniciarSincronizacao.ChildOrder := 23;
    btnReiniciarSincronizacao.HeightPercent := 100.000000000000000000;
    btnReiniciarSincronizacao.TabOrder := 4;
    btnReiniciarSincronizacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnReiniciarSincronizacao, Self, 'OnClick', 'btnReiniciarSincronizacaoClick');
    btnDesativarSincronizacao.SetParentComponent(Self);
    btnDesativarSincronizacao.Name := 'btnDesativarSincronizacao';
    btnDesativarSincronizacao.Left := 320;
    btnDesativarSincronizacao.Top := 436;
    btnDesativarSincronizacao.Width := 96;
    btnDesativarSincronizacao.Height := 25;
    btnDesativarSincronizacao.Caption := 'Desativar Sinc. Rota';
    btnDesativarSincronizacao.ChildOrder := 23;
    btnDesativarSincronizacao.HeightPercent := 100.000000000000000000;
    btnDesativarSincronizacao.TabOrder := 4;
    btnDesativarSincronizacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnDesativarSincronizacao, Self, 'OnClick', 'btnDesativarSincronizacaoClick');
    btnAtivarSincronizacao.SetParentComponent(Self);
    btnAtivarSincronizacao.Name := 'btnAtivarSincronizacao';
    btnAtivarSincronizacao.Left := 8;
    btnAtivarSincronizacao.Top := 467;
    btnAtivarSincronizacao.Width := 96;
    btnAtivarSincronizacao.Height := 25;
    btnAtivarSincronizacao.Caption := 'Ativar Sinc. Rota';
    btnAtivarSincronizacao.ChildOrder := 23;
    btnAtivarSincronizacao.HeightPercent := 100.000000000000000000;
    btnAtivarSincronizacao.TabOrder := 4;
    btnAtivarSincronizacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnAtivarSincronizacao, Self, 'OnClick', 'btnAtivarSincronizacaoClick');
    cbbAliadosSize.SetParentComponent(Self);
    cbbAliadosSize.Name := 'cbbAliadosSize';
    cbbAliadosSize.Left := 320;
    cbbAliadosSize.Top := 467;
    cbbAliadosSize.Width := 145;
    cbbAliadosSize.Height := 21;
    cbbAliadosSize.HeightPercent := 100.000000000000000000;
    cbbAliadosSize.WidthPercent := 100.000000000000000000;
    cbbAliadosSize.ItemIndex := -1;
    edtAliadosSearch.SetParentComponent(Self);
    edtAliadosSearch.Name := 'edtAliadosSearch';
    edtAliadosSearch.Left := 320;
    edtAliadosSearch.Top := 494;
    edtAliadosSearch.Width := 145;
    edtAliadosSearch.Height := 22;
    edtAliadosSearch.ChildOrder := 31;
    edtAliadosSearch.HeightPercent := 100.000000000000000000;
    edtAliadosSearch.WidthPercent := 100.000000000000000000;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Sincronizacao_ServiceDataset;
    DataSource.Left := 272;
    DataSource.Top := 200;
    Sincronizacao_ServiceDataset.SetParentComponent(Self);
    Sincronizacao_ServiceDataset.Name := 'Sincronizacao_ServiceDataset';
    Sincronizacao_ServiceDataset.AfterApplyUpdates := Sincronizacao_ServiceDatasetAfterApplyUpdates;
    Sincronizacao_ServiceDataset.EntitySetName := 'Sincronizacao_Service';
    Sincronizacao_ServiceDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_ServiceDataset.Left := 176;
    Sincronizacao_ServiceDataset.Top := 200;
    Sincronizacao_ServiceDatasetid.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetid.Name := 'Sincronizacao_ServiceDatasetid';
    Sincronizacao_ServiceDatasetid.FieldName := 'id';
    Sincronizacao_ServiceDatasettabela.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasettabela.Name := 'Sincronizacao_ServiceDatasettabela';
    Sincronizacao_ServiceDatasettabela.FieldName := 'tabela';
    Sincronizacao_ServiceDatasettabela.Required := True;
    Sincronizacao_ServiceDatasettabela.Size := 255;
    Sincronizacao_ServiceDatasetcampos_consulta.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetcampos_consulta.Name := 'Sincronizacao_ServiceDatasetcampos_consulta';
    Sincronizacao_ServiceDatasetcampos_consulta.FieldName := 'campos_consulta';
    Sincronizacao_ServiceDatasetcampos_consulta.Required := True;
    SetEvent(Sincronizacao_ServiceDatasetcampos_consulta, Self, 'OnGetText', 'Sincronizacao_ServiceDatasetcampos_consultaGetText');
    Sincronizacao_ServiceDatasetcampos_consulta.Size := 255;
    Sincronizacao_ServiceDatasetrota.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetrota.Name := 'Sincronizacao_ServiceDatasetrota';
    Sincronizacao_ServiceDatasetrota.FieldName := 'rota';
    Sincronizacao_ServiceDatasetrota.Required := True;
    Sincronizacao_ServiceDatasetrota.Size := 255;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.Name := 'Sincronizacao_ServiceDatasetprioridade_sincronizacao';
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.FieldName := 'prioridade_sincronizacao';
    Sincronizacao_ServiceDatasetexcluido.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetexcluido.Name := 'Sincronizacao_ServiceDatasetexcluido';
    Sincronizacao_ServiceDatasetexcluido.FieldName := 'excluido';
    Sincronizacao_ServiceDatasetinclusao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetinclusao.Name := 'Sincronizacao_ServiceDatasetinclusao';
    Sincronizacao_ServiceDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_ServiceDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_ServiceDatasetalteracao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetalteracao.Name := 'Sincronizacao_ServiceDatasetalteracao';
    Sincronizacao_ServiceDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_ServiceDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_ServiceDatasetexclusao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetexclusao.Name := 'Sincronizacao_ServiceDatasetexclusao';
    Sincronizacao_ServiceDatasetexclusao.FieldName := 'exclusao';
    Sincronizacao_ServiceDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_ServiceDatasetconsulta_firebird.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetconsulta_firebird.Name := 'Sincronizacao_ServiceDatasetconsulta_firebird';
    Sincronizacao_ServiceDatasetconsulta_firebird.FieldName := 'consulta_firebird';
    Sincronizacao_ServiceDatasetconsulta_firebird.Size := 255;
    XDataClientSincronizacao_ServiceGet.SetParentComponent(Self);
    XDataClientSincronizacao_ServiceGet.Name := 'XDataClientSincronizacao_ServiceGet';
    XDataClientSincronizacao_ServiceGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSincronizacao_ServiceGet, Self, 'OnLoad', 'XDataClientSincronizacao_ServiceGetLoad');
    XDataClientSincronizacao_ServiceGet.Left := 32;
    XDataClientSincronizacao_ServiceGet.Top := 192;
    cdsAliados.SetParentComponent(Self);
    cdsAliados.Name := 'cdsAliados';
    cdsAliados.AfterOpen := cdsAliadosAfterOpen;
    cdsAliados.EntitySetName := 'Sincronizacao_Aliados';
    cdsAliados.Connection := DMConnection.ApiConnection;
    cdsAliados.Left := 112;
    cdsAliados.Top := 329;
    cdsAliadosid.SetParentComponent(cdsAliados);
    cdsAliadosid.Name := 'cdsAliadosid';
    cdsAliadosid.FieldName := 'id';
    cdsAliadosid.Required := True;
    cdsAliadossincronizar_dados.SetParentComponent(cdsAliados);
    cdsAliadossincronizar_dados.Name := 'cdsAliadossincronizar_dados';
    cdsAliadossincronizar_dados.FieldName := 'sincronizar_dados';
    cdsAliadossincronizar_dados.Required := True;
    cdsAliadosultima_reinicializacao.SetParentComponent(cdsAliados);
    cdsAliadosultima_reinicializacao.Name := 'cdsAliadosultima_reinicializacao';
    cdsAliadosultima_reinicializacao.FieldName := 'ultima_reinicializacao';
    cdsAliadosultima_reinicializacao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    cdsAliadosinclusao.SetParentComponent(cdsAliados);
    cdsAliadosinclusao.Name := 'cdsAliadosinclusao';
    cdsAliadosinclusao.FieldName := 'inclusao';
    cdsAliadosinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    cdsAliadosalteracao.SetParentComponent(cdsAliados);
    cdsAliadosalteracao.Name := 'cdsAliadosalteracao';
    cdsAliadosalteracao.FieldName := 'alteracao';
    cdsAliadosalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    cdsAliadosaliadoNome_Fantasia.SetParentComponent(cdsAliados);
    cdsAliadosaliadoNome_Fantasia.Name := 'cdsAliadosaliadoNome_Fantasia';
    cdsAliadosaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    SetEvent(cdsAliadosaliadoNome_Fantasia, Self, 'OnGetText', 'cdsAliadosaliadoNome_FantasiaGetText');
    cdsAliadosselecionado.SetParentComponent(cdsAliados);
    cdsAliadosselecionado.Name := 'cdsAliadosselecionado';
    cdsAliadosselecionado.FieldKind := fkCalculated;
    cdsAliadosselecionado.FieldName := 'selecionado';
    cdsAliadosselecionado.Calculated := True;
    cdsAliadosaliado_id.SetParentComponent(cdsAliados);
    cdsAliadosaliado_id.Name := 'cdsAliadosaliado_id';
    cdsAliadosaliado_id.FieldName := 'aliado_id';
    cdsAliadosaliado_id.Required := True;
    cdsAliadosaliadoCNPJ.SetParentComponent(cdsAliados);
    cdsAliadosaliadoCNPJ.Name := 'cdsAliadosaliadoCNPJ';
    cdsAliadosaliadoCNPJ.FieldName := 'aliado.CNPJ';
    SetEvent(cdsAliadosaliadoCNPJ, Self, 'OnGetText', 'cdsAliadosaliadoCNPJGetText');
    cdsAliadosaliadosincronizar_dados.SetParentComponent(cdsAliados);
    cdsAliadosaliadosincronizar_dados.Name := 'cdsAliadosaliadosincronizar_dados';
    cdsAliadosaliadosincronizar_dados.FieldName := 'aliado.sincronizar_dados';
    cdsAliadosaliadoparceironome.SetParentComponent(cdsAliados);
    cdsAliadosaliadoparceironome.Name := 'cdsAliadosaliadoparceironome';
    cdsAliadosaliadoparceironome.FieldKind := fkCalculated;
    cdsAliadosaliadoparceironome.FieldName := 'aliado.parceiro.nome';
    SetEvent(cdsAliadosaliadoparceironome, Self, 'OnGetText', 'cdsAliadosaliadoparceironomeGetText');
    cdsAliadosaliadoparceironome.Calculated := True;
    cdsAliadosaliadosegmentoNome.SetParentComponent(cdsAliados);
    cdsAliadosaliadosegmentoNome.Name := 'cdsAliadosaliadosegmentoNome';
    cdsAliadosaliadosegmentoNome.FieldKind := fkCalculated;
    cdsAliadosaliadosegmentoNome.FieldName := 'aliado.segmento.Nome';
    SetEvent(cdsAliadosaliadosegmentoNome, Self, 'OnGetText', 'cdsAliadosaliadosegmentoNomeGetText');
    cdsAliadosaliadosegmentoNome.Calculated := True;
    cdsAliadosaliadocidadeufSigla.SetParentComponent(cdsAliados);
    cdsAliadosaliadocidadeufSigla.Name := 'cdsAliadosaliadocidadeufSigla';
    cdsAliadosaliadocidadeufSigla.FieldKind := fkCalculated;
    cdsAliadosaliadocidadeufSigla.FieldName := 'aliado.cidade.uf.Sigla';
    cdsAliadosaliadocidadeufSigla.Calculated := True;
    cdsAliadosaliadocidadeNome.SetParentComponent(cdsAliados);
    cdsAliadosaliadocidadeNome.Name := 'cdsAliadosaliadocidadeNome';
    cdsAliadosaliadocidadeNome.FieldKind := fkCalculated;
    cdsAliadosaliadocidadeNome.FieldName := 'aliado.cidade.Nome';
    SetEvent(cdsAliadosaliadocidadeNome, Self, 'OnGetText', 'cdsAliadosaliadocidadeNomeGetText');
    cdsAliadosaliadocidadeNome.Calculated := True;
    dtsAliados.SetParentComponent(Self);
    dtsAliados.Name := 'dtsAliados';
    dtsAliados.DataSet := cdsAliados;
    dtsAliados.Left := 264;
    dtsAliados.Top := 329;
    XDataWebGerenciarSincronizacao.SetParentComponent(Self);
    XDataWebGerenciarSincronizacao.Name := 'XDataWebGerenciarSincronizacao';
    XDataWebGerenciarSincronizacao.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebGerenciarSincronizacao, Self, 'OnLoad', 'XDataWebGerenciarSincronizacaoLoad');
    SetEvent(XDataWebGerenciarSincronizacao, Self, 'OnError', 'XDataWebGerenciarSincronizacaoError');
    XDataWebGerenciarSincronizacao.Left := 144;
    XDataWebGerenciarSincronizacao.Top := 464;
  finally
    lbid.AfterLoadDFMValues;
    lbtabela.AfterLoadDFMValues;
    lbcampos_consulta.AfterLoadDFMValues;
    lbrota.AfterLoadDFMValues;
    lbprioridade_sincronizacao.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbconsulta_firebird.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edtabela.AfterLoadDFMValues;
    edcampos_consulta.AfterLoadDFMValues;
    edrota.AfterLoadDFMValues;
    edprioridade_sincronizacao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    edconsulta_firebird.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    cbexcluido.AfterLoadDFMValues;
    btnAliados.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    tblAliados.AfterLoadDFMValues;
    btnMarcarDesmarcarTodos.AfterLoadDFMValues;
    btnReiniciarSincronizacao.AfterLoadDFMValues;
    btnDesativarSincronizacao.AfterLoadDFMValues;
    btnAtivarSincronizacao.AfterLoadDFMValues;
    cbbAliadosSize.AfterLoadDFMValues;
    edtAliadosSearch.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Sincronizacao_ServiceDataset.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetid.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasettabela.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetcampos_consulta.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetrota.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetexcluido.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetexclusao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetconsulta_firebird.AfterLoadDFMValues;
    XDataClientSincronizacao_ServiceGet.AfterLoadDFMValues;
    cdsAliados.AfterLoadDFMValues;
    cdsAliadosid.AfterLoadDFMValues;
    cdsAliadossincronizar_dados.AfterLoadDFMValues;
    cdsAliadosultima_reinicializacao.AfterLoadDFMValues;
    cdsAliadosinclusao.AfterLoadDFMValues;
    cdsAliadosalteracao.AfterLoadDFMValues;
    cdsAliadosaliadoNome_Fantasia.AfterLoadDFMValues;
    cdsAliadosselecionado.AfterLoadDFMValues;
    cdsAliadosaliado_id.AfterLoadDFMValues;
    cdsAliadosaliadoCNPJ.AfterLoadDFMValues;
    cdsAliadosaliadosincronizar_dados.AfterLoadDFMValues;
    cdsAliadosaliadoparceironome.AfterLoadDFMValues;
    cdsAliadosaliadosegmentoNome.AfterLoadDFMValues;
    cdsAliadosaliadocidadeufSigla.AfterLoadDFMValues;
    cdsAliadosaliadocidadeNome.AfterLoadDFMValues;
    dtsAliados.AfterLoadDFMValues;
    XDataWebGerenciarSincronizacao.AfterLoadDFMValues;
  end;
end;

end.
